import axios from 'axios';

// No REACT_APP_API_URL set (the production Docker build never has one baked
// in — see Dockerfile.api's client-builder stage) → fall back to a relative
// baseURL, i.e. same origin as the page. That's correct in production: the
// API server serves the built client itself (packages/api/src/index.ts
// mounts express.static(client-build) alongside the API routes on the same
// host/port), so "same origin" IS the right answer there. Only local dev
// (`npm start`, a separate dev server on its own port) needs an explicit
// REACT_APP_API_URL override, set via packages/client/.env.
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '',
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;
